import cn from 'classnames';
import PropTypes from 'prop-types';

import { UPDATE_PAYMENT_EXP } from 'constants/checkoutButtons';
import { PAYMENT_FIELDS } from 'constants/formFields';

import ErrorList from 'components/checkout/caap/ErrorList';
import { Column, Row, RowSpan } from 'components/checkout/caap/Layout';
import { PaymentBlock } from 'components/checkout/caap/payment/paymentlist/CardInfo';
import { CreditCardExpirationMonth, CreditCardExpirationYear } from 'components/common/CreditCardExpirationField';
import { getFieldFocusEvents } from 'helpers/CheckoutUtils';
import styles from 'styles/components/checkout/caap/payment/paymentlist/updateExpiration.scss';

const selectFocusEvents = getFieldFocusEvents(styles.expDateFieldFocus);
const wrapperStyles = { [styles.formInputWrapper]: true };
const UpdateExpiration = (componentParams , { testId }) => {
  const {
    addCreditCardNumber,
    errors,
    errorList,
    expirationMonth,
    expirationYear,
    fullName,
    isFetchingCheckoutData,
    newPayment = {},
    onPaymentTypeFieldChange,
    onUpdateCreditCardClick,
    paymentInstrumentId,
    paymentType
  } = componentParams;

  // once user edits the expiration, we need to use values from our 'newPayment'
  // object, as the value on the payment in question hasn't been updated yet
  const expirationMonthForEdit = newPayment.expirationMonth || expirationMonth;
  const expirationYearForEdit = newPayment.expirationYear || expirationYear;

  const expDateWrapperStyles = cn(
    {
      ...wrapperStyles,
      [styles.solo]: true,
      [styles.error]: hasError(PAYMENT_FIELDS.CC_EXPIRATION.fieldName, errors)
    }
  );

  const updateExpButtonId = `${UPDATE_PAYMENT_EXP}-${paymentInstrumentId}`;

  return (
    <form method="post" onSubmit={onUpdateCreditCardClick} data-test-id={testId('expiredCC')}>
      <div>
        <Row extraClass={styles.form}>
          <RowSpan span="11">
            <ErrorList errorListKey="new-payment" errorList={errorList} errorHeading="There was a problem" />
          </RowSpan>
        </Row>

        <Row>
          <RowSpan mobileSpan="12" desktopSpan="3">
            <PaymentBlock paymentType={paymentType} addCreditCardNumber={addCreditCardNumber} />
          </RowSpan>
          <RowSpan mobileSpan="12" desktopSpan="3">
            {fullName}
          </RowSpan>
          <RowSpan mobileSpan="12" desktopSpan="6">

            <Row extraClass={styles.form}>
              <RowSpan span="3">
                <Column>
                  <div { ...selectFocusEvents } className={expDateWrapperStyles}>
                    <CreditCardExpirationMonth
                      value={expirationMonthForEdit}
                      onChange={onPaymentTypeFieldChange}
                      id={PAYMENT_FIELDS.CC_EXPIRATION_MONTH.fieldName}
                      name={PAYMENT_FIELDS.CC_EXPIRATION_MONTH.fieldName} />
                  </div>
                </Column>
              </RowSpan>
              <RowSpan span="3">
                <Column isLast={true}>
                  <div { ...selectFocusEvents } className={expDateWrapperStyles}>
                    <CreditCardExpirationYear
                      value={expirationYearForEdit}
                      onChange={onPaymentTypeFieldChange}
                      id={PAYMENT_FIELDS.CC_EXPIRATION_YEAR.fieldName}
                      name={PAYMENT_FIELDS.CC_EXPIRATION_YEAR.fieldName} />
                  </div>
                </Column>
              </RowSpan>
              <RowSpan span="5" isLast={true}>
                <div className={styles.buttonContainer}>
                  <button
                    className={styles.checkoutSecondaryButton}
                    data-test-id={testId('updateThisPaymentMethod')}
                    disabled={isFetchingCheckoutData}
                    id={updateExpButtonId}
                    onClick={onUpdateCreditCardClick}
                    type="submit">
                    Update Card
                  </button>
                </div>
              </RowSpan>
            </Row>
          </RowSpan>
        </Row>
      </div>
    </form>
  );
};

const hasError = (key, errors) => errors[key] && errors[key].length;

UpdateExpiration.contextTypes = {
  testId: PropTypes.func
};

export default UpdateExpiration;
